// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"292":"business-process","600":"customer-experience"}[chunkId] + "." + {"292":"0f6d9451","600":"007e75cf"}[chunkId] + ".css";
};